import type {SVGProps} from 'react';
import {forwardRef} from 'react';

export const ServerVariantIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => {
    return (
        <svg
            width={20}
            height={20}
            fill='currentColor'
            viewBox='0 0 24 24'
            xmlns='http://www.w3.org/2000/svg'
            {...props}
            ref={ref}
        >
            <path d='M8 7V6H6v1h2zm0 10H6v1h2v-1zm7-11v1h-5V6h5zm0 11h-5v1h5v-1zm7-13c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v5c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4zm-2 0v5H4V4h16zm2 11v5c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2v-5c0-1.1.9-2 2-2h16c1.1 0 2 .9 2 2zm-2 0H4v5h16v-5z'/>
        </svg>
    );
});
